const fetcher = require('od-modules/utils/fetcher');
const trackingUtils = require('od-modules/utils/tracking.utils');

const graphqlUrl = '/frontend-api/service/graphql';

function fetchAncillariesToSkip(bookingId) {
    const operationName = 'AncillariesRetailingEvaluation';
    const query = `
query ${operationName}($shoppingCartId: ID!) {
    ancillariesRetailingEvaluation(request: { shoppingCartId: $shoppingCartId }) {
        ancillariesToSkip
    }
}
    `;
    const variables = {shoppingCartId: bookingId};
    return fetcher.post(graphqlUrl, {
        query,
        operationName,
        variables,
    }).json().then(({data} = {}) => {
        const {ancillariesRetailingEvaluation = {}} = data || {};
        return ancillariesRetailingEvaluation.ancillariesToSkip || [];
    }).then((ancillariesToSkip) => {
        trackAncillariesToSkip(ancillariesToSkip);
        return ancillariesToSkip;
    });
}

function fetchNextItineraryFunnelPage(bookingId) {
    const operationName = 'nextItineraryFunnelPage';
    const query = `
query ${operationName}(
    $currentPage: PageInput!
    $shoppingCartId: Long!
) {
    nextItineraryFunnelPage(
        request: { currentPage: $currentPage, shoppingCartId: $shoppingCartId }
    ) {
        nextPage {
            url
        }
    }
}
    `;
    const variables = {shoppingCartId: String(bookingId), currentPage: {url: 'results'}};
    return fetcher.post(graphqlUrl, {
        query,
        operationName,
        variables,
    }).json().then(({data} = {}) => {
        return data?.nextItineraryFunnelPage?.nextPage?.url || 'flexibility_bundle';
    });
}

function fetchNextDynpackFunnelPage(bookingId) {
    const operationName = 'nextDynpackFunnelPage';
    const query = `
query ${operationName}(
    $currentPage: PageInput!
    $shoppingCartId: Long!
) {
    nextDynpackFunnelPage(
        request: { currentPage: $currentPage, shoppingCartId: $shoppingCartId }
    ) {
        nextPage {
            url
        }
    }
}
    `;
    const variables = {shoppingCartId: String(bookingId), currentPage: {url: 'results'}};
    return fetcher.post(graphqlUrl, {
        query,
        operationName,
        variables,
    }).json().then(({data} = {}) => {
        return data?.nextDynpackFunnelPage?.nextPage?.url || 'checkout_passengers';
    });
}

function trackAncillariesToSkip(ancillariesToSkip = []) {
    const productToLabel = {
        'FARE_PLUS': 'farerules',
        'SUPPORT_PACK': 'sp',
        'FLIGHT_CANCELLATION_AND_FLIGHT_CANCELLATION_PLUS_MEDICAL_ASSISTANCE': 'ins',
        'CANCEL_FOR_ANY_REASON': 'c4ar',
        'INSTANT_DISRUPTION_COMPENSATION': 'idc',
    };
    const label = ancillariesToSkip.map((product) => productToLabel[product] || '').join('-') || 'legacy';

    trackingUtils.setCustomParam('smart_funnel_productstoskip', ancillariesToSkip.join('-'));
    trackingUtils.trackEventWithCategory('flights_summary', 'smart-funnel', `smart-funnel_onload_sce:${label || 'legacy'}_page:flsum`);
}


function isSmartFunnelEnabled() {
    return Odigeo.SessionScope.flow === 'mobile' &&
        Odigeo.SessionScope.flowProduct === 'flights' &&
        Odigeo.AB.getSmartFunnelFirstIterationMobile > 1;
}

module.exports = {
    isSmartFunnelEnabled,
    fetchNextItineraryFunnelPage,
    fetchNextDynpackFunnelPage,
    fetchAncillariesToSkip,
    trackAncillariesToSkip,
};
